<template>
  <div
    :class="
      configData.FlexBox ? 'flex gap-8 lg:gap-24' : 'grid md:grid-cols-2 gap-24'
    "
  >
    <MarkupGenerator
      v-if="configData?.innerMarkup"
      :page-data="{ PageContent: [...configData.innerMarkup] as any }"
      :is-page="false"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    innerMarkup?: any;
    FlexBox: boolean;
  };
}

defineProps<Props>();
</script>

<style></style>
